import { render, staticRenderFns } from "./CouponCanUse.vue?vue&type=template&id=20897e0a&scoped=true&"
import script from "./CouponCanUse.vue?vue&type=script&lang=js&"
export * from "./CouponCanUse.vue?vue&type=script&lang=js&"
import style0 from "./CouponCanUse.vue?vue&type=style&index=0&id=20897e0a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20897e0a",
  null
  
)

export default component.exports